import { z } from "zod";

const hostedVideoConfigurationSchema = z.object({
  loop: z.boolean().optional(),
  autoPlay: z.boolean().optional(),
  desktopSrc: z.string().url().catch("").optional(),
  tabletSrc: z.string().url().optional(),
  mobileSrc: z.string().url().optional(),
});

const youtubeConfigurationSchema = z.object({
  externalLinkVideo: z.string(),
});

export const videoPlayerSchema = z.object({
  videoType: z.enum(["youtube", "hosted internally"]).default("hosted internally").optional(),
  youtubeConfiguration: youtubeConfigurationSchema.optional(),
  hostedVideoConfiguration: hostedVideoConfigurationSchema.optional(),
  controlColor: z.enum(["dark", "light"]).default("dark").optional(),
  posterImage: z.string().url().optional(),
  posterAlt: z.string().default("").optional(),
  description: z.string().default("").optional(),
  title: z.string().optional(),
  duration: z.boolean().optional(),
  showFullscreen: z.boolean().optional(),
  showControls: z.boolean().optional(),
  preventMainPlayButtonClick: z.boolean().optional(),
  preload: z.boolean().optional(),
  contentSize: z.boolean().optional(),
  playLabel: z.string().optional(),
  replayLabel: z.string().optional(),
  muteLabel: z.string().optional(),
  soundOnLabel: z.string().optional(),
  seekLabel: z.string().optional(),
  volumeLabel: z.string().optional(),
  showFullScreenLabel: z.string().optional(),
  // JSON-LD / Structured Data (VideoObject schema.org)
  jsonLdUploadDate: z.string().optional(),
  jsonLdDuration: z.string().optional(),
  jsonLdIneligibleRegion: z.string().optional(),
});

export const loyaltyVideoPreviewSchema = z.object({
  videoId: z.string(),
  percentageToWatch: z.string().optional(),
  video: z.object({
    title: z.string().optional(),
    videoType: z.enum(["youtube", "hosted internally"]).default("hosted internally"),
    youtubeConfiguration: youtubeConfigurationSchema.optional(),
    hostedVideoConfiguration: hostedVideoConfigurationSchema.optional(),
    controlColor: z.enum(["dark", "light"]).default("dark").optional(),
    posterImage: z.string().optional(),
    posterAlt: z.string().default("").optional(),
    description: z.string().default("").optional(),
    duration: z.boolean().optional(),
    playLabel: z.string().optional(),
    replayLabel: z.string().optional(),
    muteLabel: z.string().optional(),
    soundOnLabel: z.string().optional(),
    showFullScreenLabel: z.string().optional(),
    showFullscreen: z.boolean().optional(),
    showControls: z.boolean().optional(),
    preventMainPlayButtonClick: z.boolean().optional(),
    preload: z.boolean().optional(),
    contentSize: z.boolean().optional(),
    disableSeek: z.boolean().optional(),
  }),
});
